module.exports = __webpack_public_path__ + "img/telefonica.7de16df7.png";